import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/jui/blog/authors',
    component: ComponentCreator('/jui/blog/authors', 'edb'),
    exact: true
  },
  {
    path: '/jui/example-app',
    component: ComponentCreator('/jui/example-app', 'd9d'),
    exact: true
  },
  {
    path: '/jui/storybook',
    component: ComponentCreator('/jui/storybook', '45d'),
    exact: true
  },
  {
    path: '/jui/docs',
    component: ComponentCreator('/jui/docs', '389'),
    routes: [
      {
        path: '/jui/docs',
        component: ComponentCreator('/jui/docs', 'e04'),
        routes: [
          {
            path: '/jui/docs',
            component: ComponentCreator('/jui/docs', '3e4'),
            routes: [
              {
                path: '/jui/docs/advanced/Mnemonic',
                component: ComponentCreator('/jui/docs/advanced/Mnemonic', '348'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/advanced/Resizer',
                component: ComponentCreator('/jui/docs/advanced/Resizer', 'e0e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/advanced/ThreeViewSplitter',
                component: ComponentCreator('/jui/docs/advanced/ThreeViewSplitter', '1b6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/components/AlertDialog',
                component: ComponentCreator('/jui/docs/components/AlertDialog', '041'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/components/Balloon',
                component: ComponentCreator('/jui/docs/components/Balloon', '8c9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/components/Button',
                component: ComponentCreator('/jui/docs/components/Button', 'e93'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/components/ButtonGroup',
                component: ComponentCreator('/jui/docs/components/ButtonGroup', '614'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/components/Checkbox',
                component: ComponentCreator('/jui/docs/components/Checkbox', '33e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/components/ComboBox',
                component: ComponentCreator('/jui/docs/components/ComboBox', 'aba'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/components/Dropdown',
                component: ComponentCreator('/jui/docs/components/Dropdown', '70a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/components/Icons',
                component: ComponentCreator('/jui/docs/components/Icons', '3d5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/components/Input',
                component: ComponentCreator('/jui/docs/components/Input', 'e60'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/components/InputField',
                component: ComponentCreator('/jui/docs/components/InputField', 'e86'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/components/LabeledControlsAlignmentProvider',
                component: ComponentCreator('/jui/docs/components/LabeledControlsAlignmentProvider', '63b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/components/Link',
                component: ComponentCreator('/jui/docs/components/Link', '3f5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/components/List',
                component: ComponentCreator('/jui/docs/components/List', '3b0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/components/Menu',
                component: ComponentCreator('/jui/docs/components/Menu', 'd2a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/components/ModalWindow',
                component: ComponentCreator('/jui/docs/components/ModalWindow', '94e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/components/Popup',
                component: ComponentCreator('/jui/docs/components/Popup', '51d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/components/ProgressBar',
                component: ComponentCreator('/jui/docs/components/ProgressBar', '474'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/components/SearchInput',
                component: ComponentCreator('/jui/docs/components/SearchInput', '19b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/components/SpeedSearch',
                component: ComponentCreator('/jui/docs/components/SpeedSearch', '365'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/components/StatusBar',
                component: ComponentCreator('/jui/docs/components/StatusBar', 'd37'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/components/Tabs',
                component: ComponentCreator('/jui/docs/components/Tabs', 'e71'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/components/Toolbar',
                component: ComponentCreator('/jui/docs/components/Toolbar', '239'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/components/Tooltip',
                component: ComponentCreator('/jui/docs/components/Tooltip', '7d2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/components/ToolWindows',
                component: ComponentCreator('/jui/docs/components/ToolWindows', 'bba'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/components/Tree',
                component: ComponentCreator('/jui/docs/components/Tree', 'e9f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/getting-started',
                component: ComponentCreator('/jui/docs/getting-started', '72b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/guides/ActionSystem',
                component: ComponentCreator('/jui/docs/guides/ActionSystem', '3ed'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/guides/Collections',
                component: ComponentCreator('/jui/docs/guides/Collections', 'd4b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jui/docs/guides/Theming',
                component: ComponentCreator('/jui/docs/guides/Theming', '4db'),
                exact: true,
                sidebar: "tutorialSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/jui/',
    component: ComponentCreator('/jui/', 'b15'),
    exact: true
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
